module.exports = __webpack_public_path__ + "img/head2.3c77c85f.png";